const _ = require('lodash');

/**
 * 
 */
export class DAG {
  constructor() {
    this.directedDAG = {};
    this.inverseDAG = {};
    this.version = 0; // Hack for Vue reactivity
  }

  
  /**
   * Add a new directed link between two nodes in the graph
   * 
   * @param {String} source Label of the source node to start the link
   * @param {String} destination Label of the destination node for the link
   */
  addLink(source, destination) {
    if (!this.directedDAG[source]) this.directedDAG[source] = [];
    if (!this.inverseDAG[destination]) this.inverseDAG[destination] = [];

    this.directedDAG[source].push(destination);
    this.inverseDAG[destination].push(source);

    this.version++;
  }


  /**
   * Remove a directed link between two nodes in the graph
   * 
   * @param {String} source Label of the source destination node
   * @param {String} destination Label of the link destination node
   */
  removeLink(source, destination) {
    if (this.directedDAG[source]) _.pull(this.directedDAG[source], destination);
    if (this.inverseDAG[destination]) _.pull(this.inverseDAG[destination], source);

    this.version++;
  }


  /**
   * Erase the node from the DAG (including all links in-and-out)
   * 
   * @param {String} nodeToErase Label of the node to erase
   */
  removeNode(nodeToErase) {
    // Remove all INBOUND links from other nodes into nodeToErase until empty
    let inputNodes = this.getInputs(nodeToErase);
    while(inputNodes.length) this.removeLink(inputNodes[0], nodeToErase);

    // Remove all OUTBOUND links from the nodeToErase to other nodes until empty
    let outputNodes = this.getOutputs(nodeToErase);
    while(outputNodes.length) this.removeLink(nodeToErase, outputNodes[0]);

    this.version++;
  }

  
  /**
   * Return all nodes with a link originating from the provided source node
   * 
   * @param {String} source Label of the source node
   */
  getOutputs(source) {
    return this.directedDAG[source] || [];
  }


  /**
   * Return all nodes with a directed link into the provided destination node
   * 
   * @param {String} destination Label of the destination
   */
  getInputs(destination) {
    return this.inverseDAG[destination] || [];
  }


  /**
   * Return a list of all nodes in the DAG that have a link
   * (nodes with no links are treated as not part of the DAG)
   */
  getNodes() {
    let sourceNodes = Object.keys(this.directedDAG).filter(n => this.directedDAG[n].length);
    let destinationNodes = Object.keys(this.inverseDAG).filter(n => this.inverseDAG[n].length);
    return _.union(sourceNodes, destinationNodes);
  }


  /**
   * Return all leaf nodes in the DAG
   * (nodes with outbound links but no inbound links)
   */
  getLeafNodes() {
    let allNodes = this.getNodes();
    return allNodes.filter(node => this.getInputs(node).length === 0);
  }


  /**
   * Return all ROOT nodes in the DAG
   * (nodes with inbound links but no output links)
   */
  getRootNodes() {
    let allNodes = this.getNodes();
    return allNodes.filter(node => this.getOutputs(node).length === 0);
  }
}